import { computed, observable } from 'mobx'
import { asNumber } from '@taxfyle/web-commons/lib/utils/numberUtil'

export default class TxfConfigViewModel {
  @observable
  txfStripeCustomerId = undefined

  @observable
  autoVerificationConfig = 'SKIP_WHEN_POSSIBLE'

  @observable
  totalCredits = undefined

  @observable
  creditSource = undefined

  @computed
  get isWallet() {
    return this.creditSource === 'WALLET'
  }

  activate(
    txfStripeCustomerId = undefined,
    autoVerificationConfig = 'SKIP_WHEN_POSSIBLE',
    totalCredits = undefined,
    creditSource = undefined
  ) {
    this.txfStripeCustomerId = txfStripeCustomerId
    this.autoVerificationConfig = autoVerificationConfig
    this.totalCredits = totalCredits
    this.creditSource = creditSource
  }

  toJSON() {
    return {
      stripe_customer_id: this.txfStripeCustomerId,
      auto_verification_config: this.autoVerificationConfig,
      // A wallet workspace's balance lives in txf-api, which ignores this field
      // entirely. Sending it would let an edit here look like it did something.
      ...(this.isWallet ? {} : { total_credits: asNumber(this.totalCredits) }),
    }
  }
}
